import { render, staticRenderFns } from "./StandardStepAdd.component.vue?vue&type=template&id=321e886b&"
import script from "./StandardStepAdd.component.vue?vue&type=script&lang=js&"
export * from "./StandardStepAdd.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardStepAdd.component.vue?vue&type=style&index=0&id=321e886b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports